import { ReactNode } from "react";

enum JobMatchType {
    resumeAndPreferences = 'general',
    specificRole = 'specificRole',
}

export const textForJobMatchType = (type: JobMatchType): ReactNode => {
    switch (type) {
        case JobMatchType.resumeAndPreferences:
            return <>Provide me with a list of job matches based on my <b>resume and job preferences</b></>
        case JobMatchType.specificRole:
            return <>Provide me with a list of jobs for a <b>specific role or position</b></>
    }
}

export default JobMatchType;